import * as React from 'react';
const SvgSpinner = (props) => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<ellipse
			opacity="0.6"
			cx="8.94969"
			cy="6.29257"
			rx="2.96531"
			ry="2.96444"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="4.5927"
			cy="12.2926"
			rx="2.59465"
			ry="2.59389"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="4.58922"
			cy="19.7087"
			rx="2.22398"
			ry="2.22333"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="8.94707"
			cy="25.708"
			rx="1.85332"
			ry="1.85278"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="16.0022"
			cy="28"
			rx="1.48266"
			ry="1.48222"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="23.0549"
			cy="25.7083"
			rx="1.11159"
			ry="1.11167"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="27.4149"
			cy="19.7068"
			rx="0.741057"
			ry="0.741111"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="27.4155"
			cy="12.29"
			rx="0.370528"
			ry="0.370556"
			fill="#A614B9"
		/>
		<ellipse
			opacity="0.4"
			cx="23.0529"
			cy="6.29017"
			rx="0.0333301"
			ry="0.0333325"
			fill="#A614B9"
		/>
		<circle cx="15.9993" cy="3.99984" r="3.33333" fill="#A614B9" />
	</svg>
);
export default SvgSpinner;
